/*!

=========================================================
* Light Bootstrap Dashboard React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/light-bootstrap-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import ProductsListView from "views/ProductsListView";
import UsersListView from "views/UsersListView";
import ProductsBoxListView from "views/ProductsBoxListView";
import fraud from "views/fraud.js";
import CashplusOperations from "views/CashplusOperations"
import BoxQrcodesFilesListView from "views/BoxQrcodesFilesListView";
import CustomerInfo from "views/CustomerInfo";
import FullyVerified from 'views/fullyverfied';

const dashboardRoutes = [
  {
    name: "Users",
    path: "/Users/",
    icon: "nc-icon nc-chart-bar-32",
    component: UsersListView,
    layout: "/admin",
    sidebarVisibility: "visible",
  },
  {
    name: "Cashplus",
    path: "/Cashplus",
    icon: "nc-icon nc-chart-bar-32",
    component: CashplusOperations,
    layout: "/admin",
    sidebarVisibility: "visible",
  },
  {
    name: "Fully Verified",
    path: "/FullyVerified",
    icon: "nc-icon nc-chart-bar-32",
    component: FullyVerified,
    layout: "/admin",
    sidebarVisibility: "visible",
  },
  {
    name: "KYC",
    path: "/kyc",
    icon: "nc-icon nc-chart-bar-32",
    component: CustomerInfo,
    layout: "/admin",
    sidebarVisibility: "visible",
  },
];

export default dashboardRoutes;
